<template>

  <div id="video">
    <div class="container">

      <app-navigation></app-navigation>

      <div class="row player">
        <youtube :video-id="$route.params.ytid"
                 :player-width="playerWidth"
                 :player-height="playerHeight"
                 :player-vars="playerVars"></youtube>
      </div>
    </div>

    <div class="control">
      <i class="fa fa-chevron-left" aria-hidden="true" @click="back"></i>
    </div>

  </div>
</template>
<script>
  import Navigation from './Navigation.vue'

  export default {
    data () {
      return {
        videoId: this.$route.params.id,
        playerWidth: '100%',
        playerHeight: '500px',
        playerVars: {
          autoplay: 1
        }
      }
    },
    methods: {
      ready (player) {
        this.player = player
      },
      playing (player) {
        // The player is playing a video.
      },
      change () {
        // when you change the value, the player will also change.
        // If you would like to change `playerVars`, please change it before you change `videoId`.
        // If `playerVars.autoplay` is 1, `loadVideoById` will be called.
        // If `playerVars.autoplay` is 0, `cueVideoById` will be called.
//        this.videoId = 'another video id'
      },
      stop () {
        this.player.stopVideo()
      },
      pause () {
        this.player.pauseVideo()
      },
      back () {
        this.$router.go(-1)
      }
    },
    components: {
      appNavigation: Navigation
    },
    created () {
    }
  }
</script>
<style lang="scss" scoped>

  @import "../style/common";

  #video {
    margin: 5rem auto;
    height: 100%;
    width: 100%;
  }

  .player {
    margin: 40px auto 20px;
  }

  .fa {
    float: left;
    /*display: block;*/
    /*background-color: yellow;*/
    padding: 1rem 3rem;
    font-size: 3rem;

  }

  .fa:hover {
    font-size: 3.5rem;
  }


</style>



// WEBPACK FOOTER //
// VideoPlayer.vue?56465576